module.exports = __webpack_public_path__ + "img/abstract-shapes-13.7b5c54ff.svg";